import { render, staticRenderFns } from "./two.vue?vue&type=template&id=64d78347&scoped=true&"
import script from "./two.vue?vue&type=script&lang=js&"
export * from "./two.vue?vue&type=script&lang=js&"
import style0 from "./two.vue?vue&type=style&index=0&id=64d78347&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d78347",
  null
  
)

export default component.exports